import React from 'react';

const FormContainer = ({ isLoading, error, onSubmit, children }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <form onSubmit={handleSubmit} className="form-container relative block">
      {isLoading && <div className="absolute top-0 left-0 w-full h-full bg-white/50 z-10">
        <svg width="64px" height="64px" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" className='absolute top-[50%] left-[50%] ml-[-32px] mt-[-32px] animate-spin'>
            <g id="SVGRepo_bgCarrier" strokeWidth="0"/>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" stroke="none" strokeWidth="0.9"/>
            <g id="SVGRepo_iconCarrier"> <path d="M4.5 12.5C4.5 16.9183 8.08172 20.5 12.5 20.5C16.9183 20.5 20.5 16.9183 20.5 12.5C20.5 8.08172 16.9183 4.5 12.5 4.5" stroke="#003D3F" strokeWidth="1"/> </g>
        </svg>
      </div>}
      {error && <div className="bg-red-500 rounded-[8px] px-[15px] py-[10px] text-center font-bold text-white mb-[20px]">{error && (Array.isArray(error) && error?.length > 0 ? <ul>{error.map((err, i) => <li key={i}>{err}</li>)}</ul> : error)}</div>}
      {children}
    </form>
  );
};

export default FormContainer;